/* ============================================================================
   PEACHES 2.0 — behaviour
   ----------------------------------------------------------------------------
   Deliberately small and dependency-free. Everything here is progressive:
   if this file fails to load, forms still submit, links still navigate, and
   the store still sells.
   ========================================================================= */
(function () {
  'use strict';

  var cfg = window.PEACHES || {};
  var moneyFormat = cfg.moneyFormat || 'LE {{amount}}';

  /* ── money ───────────────────────────────────────────────────────────── */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  }

  /* ── tiny helpers ────────────────────────────────────────────────────── */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── Cart ────────────────────────────────────────────────────────────── */
  var Cart = {
    state: null,

    get: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { Cart.state = c; Cart.emit(); return c; });
    },

    add: function (id, qty, props) {
      var body = { items: [{ id: id, quantity: qty || 1 }] };
      if (props) body.items[0].properties = props;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () { return Cart.get(); });
    },

    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) { Cart.state = c; Cart.emit(); return c; });
    },

    emit: function () {
      document.dispatchEvent(new CustomEvent('peaches:cart', { detail: Cart.state }));
    }
  };
  window.PeachesCart = Cart;

  /* ── Drawer ──────────────────────────────────────────────────────────── */
  var Drawer = {
    el: null,
    lastFocus: null,

    open: function () {
      Drawer.el = Drawer.el || $('[data-cart-drawer]');
      if (!Drawer.el) return;
      Drawer.lastFocus = document.activeElement;
      Drawer.el.hidden = false;
      // next frame so the transition runs
      requestAnimationFrame(function () { Drawer.el.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var close = $('[data-cart-close]', Drawer.el);
      if (close) close.focus();
      document.addEventListener('keydown', Drawer.onKey);
    },

    close: function () {
      if (!Drawer.el) return;
      Drawer.el.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', Drawer.onKey);
      window.setTimeout(function () { if (Drawer.el) Drawer.el.hidden = true; }, 350);
      if (Drawer.lastFocus && Drawer.lastFocus.focus) Drawer.lastFocus.focus();
    },

    onKey: function (e) {
      if (e.key === 'Escape') { Drawer.close(); return; }
      if (e.key !== 'Tab' || !Drawer.el) return;
      var f = $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', Drawer.el)
        .filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };
  window.PeachesDrawer = Drawer;

  /* ── Drawer rendering ────────────────────────────────────────────────── */
  function renderCart(cart) {
    var root = $('[data-cart-drawer]');
    if (!root) return;

    var countEls = $$('[data-cart-count]');
    countEls.forEach(function (n) {
      n.textContent = cart.item_count;
      n.hidden = cart.item_count === 0;
    });

    var body = $('[data-cart-body]', root);
    var foot = $('[data-cart-foot]', root);
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="cd__empty">' +
          '<p class="display cd__empty-title">Nothing here yet.</p>' +
          '<p class="cd__empty-sub">Your drawer is feeling a little bare.</p>' +
          '<a class="btn btn--coral" href="/collections/classic">Shop Classic</a>' +
        '</div>';
      if (foot) foot.hidden = true;
      return;
    }

    if (foot) foot.hidden = false;

    // Bundle picks (Pack 1 cut, Pack 1 Size …) ride along as line properties.
    // Show them, or the customer cannot check their choices in the bag.
    // Shopify uses a leading underscore for its own hidden properties.
    function propsHtml(it) {
      var props = it.properties;
      if (!props) return '';
      var rows = Object.keys(props).filter(function (k) {
        return k.charAt(0) !== '_' && props[k] !== null && props[k] !== '';
      });
      if (!rows.length) return '';
      return '<ul class="cd__props">' + rows.map(function (k) {
        return '<li><span>' + esc(k) + '</span> ' + esc(String(props[k])) + '</li>';
      }).join('') + '</ul>';
    }

    body.innerHTML = cart.items.map(function (it) {
      var onSale = it.original_line_price > it.final_line_price;
      return (
        '<article class="cd__item" data-key="' + esc(it.key) + '">' +
          '<a class="cd__thumb" href="' + esc(it.url) + '">' +
            (it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')) + '" alt="" loading="lazy" width="80" height="100">' : '') +
          '</a>' +
          '<div class="cd__meta">' +
            '<a class="cd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            (it.variant_title && it.variant_title !== 'Default Title'
              ? '<p class="cd__variant">' + esc(it.variant_title) + '</p>' : '') +
            propsHtml(it) +
            '<div class="cd__row">' +
              '<div class="cd__qty">' +
                '<button type="button" data-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<span aria-live="polite">' + it.quantity + '</span>' +
                '<button type="button" data-qty="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<p class="cd__price">' +
                (onSale ? '<s>' + formatMoney(it.original_line_price) + '</s> ' : '') +
                formatMoney(it.final_line_price) +
              '</p>' +
            '</div>' +
            '<button class="cd__remove" type="button" data-remove>Remove</button>' +
          '</div>' +
        '</article>'
      );
    }).join('');

    // Add-on upsell: offer it only while it is not already in the bag.
    var addon = $('[data-cart-addon]', root);
    if (addon) {
      var addonId = String(addon.getAttribute('data-addon-variant'));
      var present = cart.items.some(function (i) { return String(i.variant_id) === addonId; });
      addon.hidden = present;
    }

    var sub = $('[data-cart-subtotal]', root);
    if (sub) sub.textContent = formatMoney(cart.total_price);

    var save = $('[data-cart-saving]', root);
    if (save) {
      if (cart.total_discount > 0) {
        save.hidden = false;
        save.textContent = 'You saved ' + formatMoney(cart.total_discount);
      } else {
        save.hidden = true;
      }
    }

    // Free-shipping progress
    var threshold = parseInt(cfg.freeShipping || '0', 10) * 100;
    var prog = $('[data-ship-progress]', root);
    if (prog && threshold > 0) {
      var remain = threshold - cart.total_price;
      var pct = Math.max(0, Math.min(100, (cart.total_price / threshold) * 100));
      var bar = $('[data-ship-bar]', prog);
      var msg = $('[data-ship-msg]', prog);
      if (bar) bar.style.width = pct + '%';
      if (msg) {
        msg.innerHTML = remain > 0
          ? 'You’re ' + formatMoney(remain) + ' away from <strong>free shipping</strong>'
          : '<strong>Free shipping unlocked.</strong> Nice.';
      }
      prog.hidden = false;
    }
  }

  document.addEventListener('peaches:cart', function (e) { renderCart(e.detail); });

  /* ── Delegated events ────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var openBtn = t.closest && t.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); Cart.get().then(Drawer.open); return; }

    var closeBtn = t.closest && t.closest('[data-cart-close]');
    if (closeBtn) { e.preventDefault(); Drawer.close(); return; }

    var qtyBtn = t.closest && t.closest('[data-qty]');
    if (qtyBtn) {
      var itemEl = qtyBtn.closest('.cd__item');
      var cur = parseInt($('.cd__qty span', itemEl).textContent, 10) || 1;
      var next = cur + parseInt(qtyBtn.getAttribute('data-qty'), 10);
      Cart.change(itemEl.getAttribute('data-key'), Math.max(0, next));
      return;
    }

    var rm = t.closest && t.closest('[data-remove]');
    if (rm) {
      var el = rm.closest('.cd__item');
      Cart.change(el.getAttribute('data-key'), 0);
      return;
    }

    var addonBtn = t.closest && t.closest('[data-addon-add]');
    if (addonBtn) {
      e.preventDefault();
      var wrap = addonBtn.closest('[data-cart-addon]');
      var vid = wrap && wrap.getAttribute('data-addon-variant');
      if (!vid) return;
      var label = addonBtn.textContent;
      addonBtn.textContent = 'Adding…';
      addonBtn.setAttribute('aria-disabled', 'true');
      Cart.add(vid, 1)
        .catch(function () {})
        .then(function () {
          addonBtn.textContent = label;
          addonBtn.removeAttribute('aria-disabled');
        });
      return;
    }

    var menuOpen = t.closest && t.closest('[data-menu-open]');
    if (menuOpen) { e.preventDefault(); Menu.open(); return; }

    var menuClose = t.closest && t.closest('[data-menu-close]');
    if (menuClose) { e.preventDefault(); Menu.close(); return; }

    var guideOpen = t.closest && t.closest('[data-guide-open]');
    if (guideOpen) {
      e.preventDefault();
      var g = $('[data-guide]');
      if (g) {
        g.hidden = false;
        document.body.style.overflow = 'hidden';
        var gc = $('[data-guide-close]', g);
        if (gc) gc.focus();
      }
      return;
    }

    var guideClose = t.closest && t.closest('[data-guide-close]');
    if (guideClose) {
      e.preventDefault();
      var gg = $('[data-guide]');
      if (gg) { gg.hidden = true; document.body.style.overflow = ''; }
      return;
    }

    var fOpen = t.closest && t.closest('[data-filters-open]');
    if (fOpen) {
      e.preventDefault();
      var panel = $('[data-filters]');
      var scrim = $('.cl__scrim');
      if (panel) {
        panel.classList.add('is-open');
        if (scrim) scrim.hidden = false;
        fOpen.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        var fc = $('[data-filters-close]', panel);
        if (fc) fc.focus();
      }
      return;
    }

    var fClose = t.closest && t.closest('[data-filters-close]');
    if (fClose) {
      e.preventDefault();
      var p2 = $('[data-filters]');
      var s2 = $('.cl__scrim');
      if (p2) p2.classList.remove('is-open');
      if (s2) s2.hidden = true;
      var ob = $('[data-filters-open]');
      if (ob) { ob.setAttribute('aria-expanded', 'false'); ob.focus(); }
      document.body.style.overflow = '';
      return;
    }
  });

  /* ── Filters / sort submit on change ─────────────────────────────────── */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('[data-auto-submit]')) return;
    var form = el.closest('form');
    if (!form) return;
    // Unchecked boxes must not be submitted as empty params.
    Array.prototype.forEach.call(form.querySelectorAll('input[type="checkbox"]:not(:checked)'), function (b) {
      b.disabled = true;
    });
    form.submit();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var g = $('[data-guide]');
    if (g && !g.hidden) { g.hidden = true; document.body.style.overflow = ''; }
  });

  /* ── Mobile menu ─────────────────────────────────────────────────────── */
  var Menu = {
    el: null,
    open: function () {
      Menu.el = Menu.el || $('[data-mobile-menu]');
      if (!Menu.el) return;
      Menu.el.hidden = false;
      requestAnimationFrame(function () { Menu.el.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var btn = $('[data-menu-open]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      var first = $('a,button', Menu.el);
      if (first) first.focus();
      document.addEventListener('keydown', Menu.onKey);
    },
    close: function () {
      if (!Menu.el) return;
      Menu.el.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', Menu.onKey);
      var btn = $('[data-menu-open]');
      if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
      window.setTimeout(function () { if (Menu.el) Menu.el.hidden = true; }, 350);
    },
    onKey: function (e) {
      if (e.key === 'Escape') Menu.close();
    }
  };

  /* ── Variant selection ────────────────────────────────────────────────── */
  // The product page has two size pickers — the main one and the mobile sticky
  // bar — and each form has a single hidden name="id". Picking a size in either
  // picker must update BOTH pickers and BOTH hidden inputs, otherwise the bar
  // at the bottom of a phone keeps the old size and adds the wrong one.
  function selectVariant(id) {
    $$('input[data-variant-pill]').forEach(function (r) { r.checked = (r.value === id); });
    $$('input[data-variant-id]').forEach(function (h) {
      if (h.value === id) return;
      h.value = id;
      // Shopify's Buy it now listens for this to pick up the new variant.
      h.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[data-variant-pill]') && t.checked) selectVariant(t.value);
  });

  // Back/forward cache can restore radios without restoring the hidden input.
  window.addEventListener('pageshow', function () {
    var picked = $('input[data-variant-pill]:checked');
    if (picked) selectVariant(picked.value);
  });

  /* ── Add-to-cart forms ───────────────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-add-form]')) return;
    e.preventDefault();

    // preventDefault skips the browser's own constraint checking, so required
    // fields (the per-pack cut and size selects) have to be enforced here or
    // a bundle can reach the bag with nothing chosen.
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      var firstBad = form.querySelector(':invalid');
      if (firstBad && firstBad.focus) firstBad.focus();
      return;
    }

    // The accelerated-checkout buttons Shopify injects also live inside this
    // form, so target the real Add to bag button rather than whichever submit
    // element happens to come first.
    var btn = $('[data-main-atc]', form) || $('[type="submit"]', form);
    // Size pills are radios that ALL share name="id", so a bare querySelector
    // returns the first one in the DOM (size S) no matter which the customer
    // actually picked — they chose L and the bag received S. Read the checked
    // radio; only fall back to a plain lookup when there is no radio group
    // (single-variant products use one hidden input).
    var sizeRadios = form.querySelectorAll('input[name="id"][type="radio"]');
    var idInput = sizeRadios.length
      ? form.querySelector('input[name="id"][type="radio"]:checked')
      : form.querySelector('[name="id"]');

    if (sizeRadios.length && !idInput) {
      // Nothing selected: say so instead of silently adding the wrong size.
      if (sizeRadios[0].focus) sizeRadios[0].focus();
      if (typeof sizeRadios[0].setCustomValidity === 'function') {
        sizeRadios[0].setCustomValidity('Please choose a size.');
        if (typeof form.reportValidity === 'function') form.reportValidity();
        sizeRadios[0].setCustomValidity('');
      }
      return;
    }
    if (!idInput || !idInput.value) return;

    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.innerHTML = 'Adding…'; }

    var props = null;
    $$('[name^="properties["]', form).forEach(function (n) {
      if (!n.value) return;
      props = props || {};
      props[n.name.replace(/^properties\[|\]$/g, '')] = n.value;
    });

    var qtyField = $('[name="quantity"]', form);
    Cart.add(idInput.value, qtyField ? parseInt(qtyField.value, 10) : 1, props)
      .then(function () {
        if (btn) { btn.innerHTML = 'Added'; }
        Drawer.open();
        window.setTimeout(function () { if (btn) { btn.innerHTML = original; btn.removeAttribute('aria-disabled'); } }, 1200);
      })
      .catch(function (err) {
        if (btn) { btn.innerHTML = (err && err.description) ? 'Unavailable' : 'Try again'; }
        window.setTimeout(function () { if (btn) { btn.innerHTML = original; btn.removeAttribute('aria-disabled'); } }, 1800);
      });
  });

  /* ── Contact form → WhatsApp ─────────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-wa-form]')) return;

    var number = (form.getAttribute('data-wa-number') || '').replace(/\D/g, '');
    // No number configured: fall through to the normal Shopify contact form.
    if (!number) return;

    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      return;
    }
    e.preventDefault();

    function val(name) {
      var el = form.querySelector('[name="' + name + '"]');
      return el && el.value ? el.value.trim() : '';
    }

    var lines = ['Hi Peaches!'];
    var name = val('contact[name]');
    var email = val('contact[email]');
    var order = val('contact[order]');
    var body = val('contact[body]');

    if (name) lines.push('Name: ' + name);
    if (email) lines.push('Email: ' + email);
    if (order) lines.push('Order: ' + order);
    if (body) lines.push('', body);

    var url = 'https://wa.me/' + number + '?text=' + encodeURIComponent(lines.join('\n'));
    // A user-gesture-initiated open, so it is not treated as a popup.
    window.open(url, '_blank', 'noopener');
  });

  /* ── Reveal on scroll ────────────────────────────────────────────────── */
  function initReveal() {
    var nodes = $$('[data-reveal]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var d = en.target.getAttribute('data-reveal-delay');
        if (d) en.target.style.transitionDelay = d + 'ms';
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ── Header state ────────────────────────────────────────────────────── */
  function initHeader() {
    var head = $('[data-header]');
    if (!head) return;
    function onScroll() {
      // Only a shadow state; the bar itself never leaves the viewport.
      head.classList.toggle('is-stuck', window.scrollY > 12);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile sticky add-to-cart ───────────────────────────────────────── */
  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var main = $('[data-main-atc]');
    if (!bar || !main) return;

    function show(on) {
      if (on && bar.hidden) bar.hidden = false;
      requestAnimationFrame(function () { bar.classList.toggle('is-on', on); });
    }

    if (!('IntersectionObserver' in window)) { show(true); return; }

    // Visible whenever the real button is NOT on screen, so the two never
    // compete for the same tap.
    var io = new IntersectionObserver(function (entries) {
      show(!entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -72px 0px', threshold: 0 });
    io.observe(main);
  }

  /* ── Welcome offer ───────────────────────────────────────────────────── */
  var WO_KEY = 'peaches:welcome';

  function woSeen() {
    try { return localStorage.getItem(WO_KEY); } catch (e) { return null; }
  }

  function woMark(state) {
    try { localStorage.setItem(WO_KEY, state); } catch (e) {}
  }

  function woKey(e) {
    if (e.key === 'Escape') closeWelcome();
  }

  function openWelcome(el) {
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    var closeBtn = $('[data-welcome-close]', el);
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keydown', woKey);
  }

  function closeWelcome() {
    var el = $('[data-welcome]');
    if (!el) return;
    el.classList.remove('is-on');
    if (!woSeen()) woMark('dismissed');
    document.removeEventListener('keydown', woKey);
    window.setTimeout(function () { el.hidden = true; }, 350);
  }

  function initWelcome() {
    var el = $('[data-welcome]');
    if (!el) return;

    // Back from a successful signup: Shopify redirected with customer_posted=true,
    // so the template rendered the success state with data-welcome-reveal.
    // Show it once more with the code, then never again.
    if ($('[data-welcome-reveal]', el)) {
      woMark('subscribed');
      openWelcome(el);
      return;
    }

    if (woSeen()) return;

    var delay = (parseInt(el.getAttribute('data-delay'), 10) || 6) * 1000;
    window.setTimeout(function () {
      if (!woSeen()) openWelcome(el);
    }, delay);
  }

  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-welcome-close]');
    if (c) { e.preventDefault(); closeWelcome(); }
  });

  function init() {
    initReveal();
    initHeader();
    initStickyAtc();
    initWelcome();
    Cart.get();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
